import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ProjectsAdmin from './ProjectsAdmin';
import HomeAdmin from './HomeAdmin';
import AboutAdmin from './AboutAdmin';
import ContactAdmin from './ContactAdmin';
import AddProject from './AddProject';

const Dashboard = () => {
    return (
      <Routes>
        <Route path="/" element={<HomeAdmin />} />
        <Route path="/projects" element={<ProjectsAdmin />} />
        <Route path="/projects/add" element={<AddProject />} />
        <Route path="/about" element={<AboutAdmin />} />
        <Route path="/contact" element={<ContactAdmin />} />
      </Routes>
    );
  };
  
export default Dashboard;
